var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { connect } from '@/overmind';
import { getRecordCategories, createRecordCategory, deleteRecordCategory, } from '@/clients/applets';
import { NotificationService } from '@/services/NotificationService';
let RecordAppConfig = class RecordAppConfig extends Vue {
    constructor() {
        super(...arguments);
        this.tab = 'categories';
        this.newCategoryName = '';
        this.categories = [];
        this.loadingCategories = false;
        this.creating = false;
        this.loading = true;
    }
    get hasPermission() {
        const role = this.userState.userLoggedRole ||
            (this.userState.currentUser && this.userState.currentUser.role) ||
            '';
        return role.toLowerCase() === 'admin' || role.toLowerCase() === 'owner';
    }
    async created() {
        this.loading = true;
        try {
            await this.userActions.getUserMe();
            if (this.hasPermission) {
                await this.fetchCategories();
            }
        }
        catch (error) {
            console.error('Error checking permissions:', error);
        }
        finally {
            this.loading = false;
        }
    }
    async fetchCategories() {
        this.loadingCategories = true;
        try {
            const userId = this.userState.currentUser && this.userState.currentUser.id;
            const response = await getRecordCategories(userId);
            this.categories =
                (response && response.data && response.data.categories) || [];
        }
        catch (error) {
            console.error('Error fetching categories:', error);
        }
        finally {
            this.loadingCategories = false;
        }
    }
    async createCategory() {
        const name = this.newCategoryName.trim();
        if (!name)
            return;
        this.creating = true;
        try {
            const res = await createRecordCategory(name);
            const success = res && (res.status === 200 || res.status === 201);
            if (success) {
                NotificationService.success('Sucesso', 'Categoria criada com sucesso!');
                this.newCategoryName = '';
                await this.fetchCategories();
            }
            else {
                NotificationService.error('Erro', 'Erro ao criar categoria.');
            }
        }
        catch (error) {
            console.error('Error creating category:', error);
            NotificationService.error('Erro', 'Ocorreu um erro ao criar a categoria.');
        }
        finally {
            this.creating = false;
        }
    }
    confirmDelete(category) {
        this.$q
            .dialog({
            title: 'Confirmar exclusão',
            message: `Tem certeza que deseja excluir a categoria "${category.name}"?`,
            cancel: {
                flat: true,
                label: 'Cancelar',
                color: 'grey-7',
            },
            ok: {
                unelevated: true,
                label: 'Excluir',
                color: 'negative',
            },
            persistent: true,
        })
            .onOk(() => {
            this.deleteCategory(category.id);
        });
    }
    async deleteCategory(id) {
        try {
            const res = await deleteRecordCategory(id);
            const success = res && (res.status === 200 || res.status === 204);
            if (success) {
                NotificationService.success('Sucesso', 'Categoria excluída com sucesso!');
                await this.fetchCategories();
            }
            else {
                NotificationService.error('Erro', 'Erro ao excluir categoria.');
            }
        }
        catch (error) {
            console.error('Error deleting category:', error);
            NotificationService.error('Erro', 'Ocorreu um erro ao excluir a categoria.');
        }
    }
};
RecordAppConfig = __decorate([
    Component(connect(({ state, actions }) => ({
        userState: state.users,
        userActions: actions.users,
        companiesActions: actions.companies,
    }), {
        name: 'RecordAppConfig',
    }))
], RecordAppConfig);
export default RecordAppConfig;
